var _plate = require("@ua/plate")
var template = new _plate("{% for error in items.objects %}\n    <tr class=\"{{ error.severity }}-item\">\n        <td class=\"error-type\">\n            <span class=\"sprite {{ error.severity }}-ico\"></span>\n        </td>\n        <td class=\"description\">\n            <h4>{{ error.description|wordwrap:32|linebreaksbr }}</h4>\n            {% if error.notification %}\n              <p>Original Message: {{ error.notification }}</p>\n            {% endif %}\n        </td>\n        <td class=\"occurred\">\n            {{ error.timestamp|timesince }} ago\n        </td>\n    </tr>\n{% empty %}\n  <tr>No errors. Great JOB!</tr>\n{% endfor %}\n")

var original_render = template.render
template.render = function(context, ready) {

if(window.dbg) dbg.time("render:" + "plate-template.html")
return original_render.call(this, context, onend)
  function onend(err, data) {
    if(window.dbg) { dbg.timeEnd("render:" + "plate-template.html") }
    if(err) { console.error("plate-template.html" + ":" + err.stack) }

    return ready(err, data)
  }
}
module.exports = template